import * as model from "@/model/adm/Log";
import {newEntityStoreHelper} from "@/store/common/entityModule";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.Log(), newFilter)
    .withStates({
        idReport: 2,
        baseModuleUrl : process.env.VUE_APP_ADM_API_URL + "adm-service/adm"
    })    
    .buildStore()
